// src/components/ContactForm.js

import React from "react";

const ContactForm = ({ id }) => {
  return (
    <div id={id} className="flex justify-center items-center min-h-screen ">
      <div className="w-full max-w-md p-8 bg-[#071633] text-white rounded-lg shadow-lg">
        <h1 className="text-3xl font-bold text-center mb-4">CONTACT US</h1>
        
        <form className="space-y-6">
          <div>
            <input
              type="text"
              placeholder="Your Name"
              className="w-full p-3 text-blue-300 bg-transparent border border-blue-500 rounded focus:outline-none focus:ring-2 focus:ring-blue-300"
            />
          </div>
          <div>
            <input
              type="email"
              placeholder="Your Mail"
              className="w-full p-3 text-blue-300 bg-transparent border border-blue-500 rounded focus:outline-none focus:ring-2 focus:ring-blue-300"
            />
          </div>
          <div>
            <textarea
              placeholder="Your Message"
              className="w-full p-3 text-blue-300 bg-transparent border border-blue-500 rounded focus:outline-none focus:ring-2 focus:ring-blue-300 h-32"
            ></textarea>
          </div>
          <div className="text-center">
            <button
              type="submit"
              className="w-full p-3 text-blue-800 bg-white rounded hover:bg-blue-300 transition-colors"
            >
              SUBMIT
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ContactForm;


